const delay = timeout =>
  new Promise(resolve => {
    setTimeout(resolve, timeout);
  });

class Multiplexer {
  constructor(strategy) {
    this.strategy = strategy;
    this.cache = {};
    this.bufferPromise = null;
    this.stopBuffering = this.stopBuffering.bind(this);
  }

  startBuffering() {
    return (
      this.bufferPromise ||
      (this.bufferPromise = delay(0).then(this.stopBuffering))
    );
  }

  stopBuffering() {
    const ids = Object.keys(this.cache);
    this.bufferPromise = null;
    this.cache = {};
    return this.flushBuffer(ids);
  }

  flushBuffer(ids) {
    const flush = this.strategy.flush(ids);
    return flush.then(response => {
      return response.reduce((memo, item) => {
        const id = this.strategy.serialize(item);
        memo[id] = item;
        return memo;
      }, {});
    });
  }

  add(id) {
    if (this.cache[id]) return this.cache[id];
    const main = this.startBuffering();
    return (this.cache[id] = main.then(
      responseMap =>
        responseMap[id] ||
        Promise.reject(new Error(`No matching response for ${id}`))
    ));
  }
}

export default Multiplexer;
